import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=52bb20ae&scoped=true&"
import script from "./text-input.vue?vue&type=script&lang=js&"
export * from "./text-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb20ae",
  null
  
)

export default component.exports